import { InputBase } from '@mui/material'
import styled from 'styled-components'

export const StyledInputBase = styled(InputBase)<{backgroundColor?: string, width?: string}>`
    color: #333;
    font-size: 16px;
    border: 1px solid #000;
    height: 28px;
    background-color: ${({ backgroundColor }) => backgroundColor || '#FFFFFF'};
    width: ${({ width }) => width || '100%'};
    
    &:focus {
        border-color: #aaa;
    }
`
